/* ============================================================
   Aimrite Speargun Size Guide — interactive size finder + sticky CTA
   Content lives in the Liquid section; this only toggles state.
   ============================================================ */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('.aim-sg');
    if (!root) return;

    /* ---- Size finder ---- */
    var opts = root.querySelectorAll('[data-sg-opt]');
    var panels = root.querySelectorAll('[data-sg-panel]');
    var placeholder = root.querySelector('[data-sg-placeholder]');

    function select(key) {
      opts.forEach(function (o) { o.classList.toggle('is-active', o.getAttribute('data-sg-opt') === key); });
      var matched = false;
      panels.forEach(function (p) {
        var on = p.getAttribute('data-sg-panel') === key;
        p.classList.toggle('is-shown', on);
        if (on) matched = true;
      });
      if (placeholder) placeholder.style.display = matched ? 'none' : '';
    }

    opts.forEach(function (o) {
      o.addEventListener('click', function () { select(o.getAttribute('data-sg-opt')); });
    });

    /* ---- Sticky CTA: show after hero scrolls out, hide near the footer CTA ---- */
    var sticky = root.querySelector('[data-sg-sticky]');
    var hero = root.querySelector('.aim-sg__hero');
    var finalCta = root.querySelector('[data-sg-finalcta]');
    if (sticky && 'IntersectionObserver' in window) {
      var pastHero = false, atEnd = false;
      function update() { sticky.classList.toggle('is-shown', pastHero && !atEnd); }
      if (hero) {
        new IntersectionObserver(function (e) {
          pastHero = !e[0].isIntersecting; update();
        }, { threshold: 0 }).observe(hero);
      }
      if (finalCta) {
        new IntersectionObserver(function (e) {
          atEnd = e[0].isIntersecting; update();
        }, { threshold: 0 }).observe(finalCta);
      }
    }
  });
})();
